export enum Fields {
  Text = 'text',
  Email = 'email',
  Prefix = 'prefix',
  Phone = 'phone',
  Message = 'message',
  Select = 'select'
}
